import { render, staticRenderFns } from "./SelectorVariables.vue?vue&type=template&id=038b76de"
import script from "./SelectorVariables.vue?vue&type=script&lang=js"
export * from "./SelectorVariables.vue?vue&type=script&lang=js"
import style0 from "./SelectorVariables.vue?vue&type=style&index=0&id=038b76de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports